import { Injectable, inject } from '@angular/core';
import { Observable, shareReplay, throwError } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { UserApiService } from 'shared';

import { OneGoUser } from '../models';
import { HeaderService } from './header.service';

@Injectable({
    providedIn: 'root',
})
export class OneGoUserService {
    private readonly headerService = inject(HeaderService);
    private readonly usersApi = inject(UserApiService);
    private _user$?: Observable<OneGoUser>;

    public getMe(): Observable<OneGoUser> {
        if (!this._user$) {
            this._user$ = this.headerService.loggedIn.pipe(
                switchMap((loggedIn) =>
                    loggedIn
                        ? this.usersApi.getMe()
                        : throwError(() => new Error('Cannot load the current user: not authenticated'))
                ),
                map((u) => u as OneGoUser),
                shareReplay(1)
            );
        }
        return this._user$;
    }
}
